import React from 'react';
import handleTrackingSublevel from './actions/handleTrackingSublevel';
import { trackStructEvent } from '../utils/snowplow';

export default function TopMenuSublevel(props) {
  const cta = handleTrackingSublevel(props.id);

  return (
    <ul className="something" data-cta={cta}>
      {props.items.map((item) => {
        // All of the clones have not online property. We display them always.
        if (item.online === true || !item.hasOwnProperty('online')) {
          const href = `${item.slug[0] === '/' ? item.slug : `/${item.slug}`}`;

          return (
            <li key={item.base_item_id}>
              <a
                href={href}
                data-cta={cta}
                onClick={() => {
                  trackStructEvent(
                    'navigationItem',
                    'click',
                    item.base_item_id,
                    { level: 2 },
                  );
                }}
              >
                {item.title}
              </a>
            </li>
          );
        }

        return null;
      })}
    </ul>
  );
}
